import _get from "lodash/get";
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { baseTheme } from '~base-theme';
var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "n34lxj-0"
})(["align-items:center;border:1px solid ", ";border-radius:", ";display:flex;padding:", ";", ""], function (_ref) {
  var theme = _ref.theme;
  return _get(theme, 'base.grays.grayLightest', baseTheme.base.grays.grayLightest);
}, function (_ref2) {
  var theme = _ref2.theme;
  return rem(_get(theme, 'base.borderRadius.default', baseTheme.base.borderRadius.default));
}, rem(8), function (_ref3) {
  var orientation = _ref3.orientation;
  return orientation === 'portrait' && css(["flex-wrap:wrap;"]);
});
export default Container;